import {
  asyncActionError,
  asyncActionStart,
  asyncActionFinish,
  asyncActionActivityStart,
  asyncActionActivityError,
  asyncActionActivityFinish
} from "../../features/async/asyncActions";
import { FETCH_ACTIVITY, TEST_ATTENDED } from "./UserDetailConstants";
import firebase from "../../config/firebase";
import { objectToArray } from "./helper.js";
// import cuid from "cuid";
import { isEmpty } from "react-redux-firebase";

export const getActivityList = (userId, lastActivity) => async (
  dispatch,
  getState
) => {
  let today = new Date(Date.now());
  // const firestore = firebase.firestore();
  const activityRef = await firebase
    .firestore()
    .collection("users")
    .doc(userId)
    .collection("activity");

  // console.log(
  //     "getActivityList() called activityRef",
  //     activityRef,
  //     lastActivity,
  //     userId
  // );

  try {
    dispatch(asyncActionActivityStart());
    let startAfter =
      lastActivity &&
      (await firebase
        .firestore()
        .collection("users")
        .doc(userId)
        .collection("activity")
        .doc(lastActivity.id)
        .get());
    let query;

    lastActivity
      ? (query = activityRef
          .where("takenAt", "<=", today)
          .orderBy("takenAt", "desc")
          .startAfter(startAfter)
          .limit(5))
      : (query = activityRef
          .where("takenAt", "<=", today)
          .orderBy("takenAt", "desc")
          .limit(5));

    let querySnap = await query.get();
    // console.log("query snap ", querySnap);
    if (querySnap.docs.length === 0) {
      dispatch(asyncActionActivityFinish());
      return querySnap;
    }

    let activities = [];

    for (let i = 0; i < querySnap.docs.length; i++) {
      let attendees = [];
      let attendeesSnap = await firebase
        .firestore()
        .collection(querySnap.docs[i].data().testCollection)
        .doc(querySnap.docs[i].data().testId)
        .get();
      if (!isEmpty(attendeesSnap.data().attendees)) {
        attendees = objectToArray(attendeesSnap.data().attendees);
      }
      let activity = {
        ...querySnap.docs[i].data(),
        id: querySnap.docs[i].id,
        attendees
        // newId: cuid()
      };
      activities.push(activity);
    }
    dispatch({ type: FETCH_ACTIVITY, payload: { activities } });
    dispatch(asyncActionActivityFinish());
    return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionActivityError());
  }
};

export const getAttendedTest = userId => async dispatch => {
  // const firestore = firebase.firestore();
  const activityRef = await firebase
    .firestore()
    .collection("users")
    .doc(userId)
    .collection("activity");
  console.log("getAttendedTest() called activityRef", userId);

  try {
    dispatch(asyncActionStart());
    let testDocSnaps = await activityRef.get();
    let testAttended = [];
    for (let i = 0; i < testDocSnaps.docs.length; i++) {
      testAttended.push(testDocSnaps.docs[i].data());
      // testAttended.push(attendees);
    }
    dispatch({ type: TEST_ATTENDED, payload: { testAttended } });
    dispatch(asyncActionFinish());
  } catch (error) {
    dispatch(asyncActionError());
    console.log(error);
  }
};

export const getSubjectWiseTest = (userId, subject) => async dispatch => {
  // const firestore = firebase.firestore();
  const activityRef = await firebase
    .firestore()
    .collection("users")
    .doc(userId)
    .collection("activity")
    .where("subject", "==", subject);
  console.log("getSubjectWiseTest() called activityRef", userId, subject);

  try {
    dispatch(asyncActionStart());
    let testDocSnaps = await activityRef.get();
    let testAttended = [];
    for (let i = 0; i < testDocSnaps.docs.length; i++) {
      testAttended.push(testDocSnaps.docs[i].data());
      // testAttended.push(attendees);
    }
    dispatch({ type: TEST_ATTENDED, payload: { testAttended } });
    dispatch(asyncActionFinish());
  } catch (error) {
    dispatch(asyncActionError());
    console.log(error);
  }
};
